/* ============================================================
   Loaded Waters — instant page prefetch
   Prefetches the next storefront page the moment a visitor hovers or
   touches a link, so it is already in the browser cache on click.
   (Same idea as instant.page, tuned for Shopify.)

   Safe by design:
   - same-origin storefront pages only (/, /products, /collections, /pages, /blogs)
   - never touches /cart, /checkout, /account, /search, links with a
     query string or #anchor, target=_blank, download or rel=nofollow links
   - add data-no-instant to any <a> to opt it out
   - disabled on Data Saver / 2G connections and inside the theme editor
   - prefetch only (never prerender), so analytics and pixels are not
     fired for pages the visitor never opens
   ============================================================ */
(function () {
  'use strict';
  if (window.__lwPrefetch) return;
  window.__lwPrefetch = true;

  var conn = navigator.connection;
  if (conn && (conn.saveData || /2g/i.test(conn.effectiveType || ''))) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var ALLOW = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:$|(?:products|collections|pages|blogs)(?:\/|$))/i;
  var SKIP_SELECTOR = '[data-no-instant], [rel~="nofollow"], [download], [target="_blank"], a[href*="#"]';

  /* 1) Native Speculation Rules (Chrome / Edge 121+):
        prefetch after ~200ms hover or on pointerdown. */
  var hasRules = typeof HTMLScriptElement !== 'undefined' &&
    typeof HTMLScriptElement.supports === 'function' &&
    HTMLScriptElement.supports('speculationrules');

  if (hasRules) {
    try {
      var rules = document.createElement('script');
      rules.type = 'speculationrules';
      rules.textContent = JSON.stringify({
        prefetch: [{
          source: 'document',
          where: {
            and: [
              { href_matches: ['/', '/products/*', '/collections/*', '/pages/*', '/blogs/*'] },
              { not: { href_matches: '/*\\?*' } },
              { not: { selector_matches: SKIP_SELECTOR } }
            ]
          },
          eagerness: 'moderate'
        }]
      });
      document.head.appendChild(rules);
      return;
    } catch (e) { /* fall through to the link-prefetch fallback */ }
  }

  /* 2) Fallback (Firefox, older Chromium): <link rel="prefetch"> on hover / touch. */
  var probe = document.createElement('link');
  if (!(probe.relList && probe.relList.supports && probe.relList.supports('prefetch'))) return;

  var HOVER_DELAY = 65;
  var done = Object.create(null);
  var timer = null;

  function anchorFor(node) {
    if (!node || typeof node.closest !== 'function') return null;
    var a = node.closest('a[href]');
    if (!a) return null;
    if (a.origin !== location.origin) return null;
    if (a.search || a.hash) return null;
    if (!ALLOW.test(a.pathname)) return null;
    if (a.matches(SKIP_SELECTOR)) return null;
    if (a.pathname === location.pathname) return null;
    return a;
  }

  function prefetch(url) {
    if (done[url]) return;
    done[url] = 1;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    document.head.appendChild(l);
  }

  document.addEventListener('mouseover', function (e) {
    var a = anchorFor(e.target);
    if (!a) return;
    clearTimeout(timer);
    timer = setTimeout(function () { timer = null; prefetch(a.pathname); }, HOVER_DELAY);
  }, { capture: true, passive: true });

  document.addEventListener('mouseout', function (e) {
    if (!timer) return;
    var from = anchorFor(e.target);
    var to = anchorFor(e.relatedTarget);
    if (from && from === to) return; /* still inside the same link */
    clearTimeout(timer);
    timer = null;
  }, { capture: true, passive: true });

  document.addEventListener('touchstart', function (e) {
    var a = anchorFor(e.target);
    if (a) prefetch(a.pathname);
  }, { capture: true, passive: true });
})();
